import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa';
import { APP_CONFIG } from '../../../constants/config';
import { NAVIGATION_ITEMS } from '../../../constants/navigation';
import './Footer.css';

/**
 * Componente Footer
 * Pie de página con información de contacto y enlaces
 */
const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer__content">
                    {/* Información del colegio */}
                    <div className="footer__section">
                        <div className='footer__logo-container'>
                            <img
                                src="/assets/images/logo.png"
                                alt="logo"
                                className="footer__logo"
                            />
                        </div>
                        <h3 className="footer__title">{APP_CONFIG.name}</h3>
                        <p className="footer__description">
                            {APP_CONFIG.slogan}
                        </p>
                    </div>

                    {/* Enlaces rápidos */}
                    <div className="footer__section">
                        <h4 className="footer__subtitle">Enlaces Rápidos</h4>
                        <ul className="footer__links">
                            {NAVIGATION_ITEMS.slice(0, 5).map((item) => (
                                <li key={item.id}>
                                    <Link to={item.path} className="footer__link">
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contacto */}
                    <div className="footer__section">
                        <h4 className="footer__subtitle">Contacto</h4>
                        <ul className="footer__contact">
                            {APP_CONFIG.contact.phones.map((phone, index) => (
                                <li key={index}>
                                    <a href={`tel:${phone.replace(/\s/g, '')}`} className="footer__link">
                                        {phone}
                                    </a>
                                </li>
                            ))}
                            <li>
                                <a href={`mailto:${APP_CONFIG.contact.email}`} className="footer__link">
                                    {APP_CONFIG.contact.email}
                                </a>
                            </li>
                            <li className="footer__address">
                                {APP_CONFIG.contact.fullAddress}
                            </li>
                        </ul>
                    </div>

                    {/* Redes sociales */}
                    <div className="footer__section">
                        <h4 className="footer__subtitle">Síguenos</h4>
                        <div className="footer__social">
                            <a
                                href={APP_CONFIG.social.facebook}
                                className="footer__social-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Facebook"
                            >
                                <FaFacebookF size={24} />
                            </a>
                            <a
                                href={APP_CONFIG.social.instagram}
                                className="footer__social-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Instagram"
                            >
                                <FaInstagram size={24} />
                            </a>
                            <a
                                href={APP_CONFIG.social.youtube}
                                className="footer__social-link"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="YouTube"
                            >
                                <FaYoutube size={24} />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="footer__bottom">
                    <p className="footer__copyright">
                        © {currentYear} <a href="https://vivawebperu.com" className='footer__link' target="_blank" rel="noopener noreferrer">VivawebPerú</a>. Todos los derechos reservados.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
